import { render, staticRenderFns } from "./AddKbli.vue?vue&type=template&id=6ff9258e&scoped=true&"
import script from "./AddKbli.vue?vue&type=script&lang=js&"
export * from "./AddKbli.vue?vue&type=script&lang=js&"
import style0 from "./AddKbli.vue?vue&type=style&index=0&id=6ff9258e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff9258e",
  null
  
)

export default component.exports